(function () {
  if (window.__4sDiscountRemoveBound) return;
  window.__4sDiscountRemoveBound = true;
  function closestAttr(node, attr) {
    while (node && node.nodeType === 1) {
      if (node.hasAttribute && node.hasAttribute(attr)) return node;
      node = node.parentNode;
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    const btn = closestAttr(e.target, 'data-discount-remove');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.style.opacity = '0.5';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .catch(() => {})
      .finally(() => window.location.reload());
  });
})();

if (!customElements.get('discount-reveal')) {
  customElements.define(
    'discount-reveal',
    class DiscountReveal extends HTMLElement {
      connectedCallback() {
        this.code = this.dataset.code;
        this.unlocked = this.dataset.unlocked === 'true';
        if (!this.unlocked || !this.code) return;

        const revealBtn = this.querySelector('[data-reveal]');
        const codeWrap = this.querySelector('[data-code-wrap]') || this.querySelector('._4s-discount-reveal__code-wrap');
        const applyBtn = this.querySelector('[data-apply]');

        if (revealBtn && codeWrap) {
          revealBtn.addEventListener('click', () => {
            codeWrap.hidden = false;
            revealBtn.hidden = true;
          });
        }

        if (applyBtn) {
          applyBtn.addEventListener('click', () => {
            applyBtn.disabled = true;
            const isCopyBtn = applyBtn.classList.contains('_4s-discount-reveal__copy-btn');
            const apply = () => this.applyDiscount(applyBtn);
            if (isCopyBtn && navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(this.code).then(() => {
                applyBtn.classList.add('is-copied');
                setTimeout(apply, 250);
              }).catch(apply);
            } else {
              apply();
            }
          });
        }
      }

      cartPageSections() {
        const out = [];
        const items = document.getElementById('main-cart-items');
        const footer = document.getElementById('main-cart-footer');
        if (items) out.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
        if (footer) out.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
        out.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
        return out;
      }

      applyDiscount(applyBtn) {
        const drawer = document.querySelector('cart-drawer');
        const onCartPage = this.dataset.context === 'cart-page' || (!drawer && !!document.getElementById('main-cart-items'));

        let sectionIds;
        if (onCartPage) {
          sectionIds = this.cartPageSections().map((s) => s.section);
        } else {
          sectionIds = ['cart-drawer', 'cart-icon-bubble'];
        }

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: this.code, sections: sectionIds, sections_url: window.location.pathname })
        })
          .then((r) => r.json())
          .then((data) => {
            if (!data || !data.sections) {
              window.location.reload();
              return;
            }
            if (onCartPage) {
              this.cartPageSections().forEach((s) => {
                const host = document.getElementById(s.id);
                const target = (host && host.querySelector(s.selector)) || host;
                const raw = data.sections[s.section];
                if (!target || !raw) return;
                const parsed = new DOMParser().parseFromString(raw, 'text/html').querySelector(s.selector);
                if (parsed) target.innerHTML = parsed.innerHTML;
              });
            } else if (drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents(data);
            } else {
              window.location.reload();
            }
          })
          .catch(() => window.location.reload());
      }
    }
  );
}
